module.exports = __webpack_public_path__ + "static/transparency-quotes-57c5c420ef2251801432bd6763c53a27.webm";